import { ToastContainer, toast } from 'react-toastify';

import 'react-toastify/dist/ReactToastify.min.css';

// in 2 seconds
const TOASTER_AUTO_CLOSE = 2000;

function MainToastContainer({ config = {} }) {
  return (
    <ToastContainer
      position="bottom-center"
      autoClose={TOASTER_AUTO_CLOSE}
      hideProgressBar
      newestOnTop={false}
      closeOnClick
      rtl={false}
      pauseOnFocusLoss={false}
      draggable
      pauseOnHover
      theme="dark"
      {...config}
    />
  );
}

export { MainToastContainer, toast as notifier, TOASTER_AUTO_CLOSE };
